// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import iView from "view-design";
import config from "@/config";
import importDirective from "@/directive";
import installPlugin from "@/plugin";
import search from "@/components/search/search";
import joinBox from "@/components/boxManage/joinBox";
import cancelBox from "@/components/boxManage/cancelBox";
import orderBoxList from "@/components/boxManage/orderBoxList";
import globalPrint from "@/components/globalPrint";
import "./index.less";
import "@/assets/icons/iconfont.css";
// 小程序使用的图标文件

Vue.component("search", search);
Vue.component("joinBox", joinBox);
Vue.component("cancelBox", cancelBox);
Vue.component("orderBoxList", orderBoxList);
Vue.component("globalPrint", globalPrint);
// 实际打包时应该不引入mock
/* eslint-disable */
//if (process.env.NODE_ENV !== 'production') require('@/mock')
Vue.use(iView, {});
/**
 * @description 注册admin内置插件
 */
installPlugin(Vue);
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false;
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config;
/**
 * 注册指令
 */
importDirective(Vue);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});


// router.beforeEach((to, from, next) => {
//   console.log("当前标签列表");
//   let arr = store.state.app.tagNavList;
//   if (from.name == "knowledgeEdit") {
//     let obj = {
//       name: from.name,
//       meta: from.meta,
//       params: from.params,
//       query: from.query,
//       path: from.path
//     };
//     TagNav.methods.close(obj, arr, TagNav);
//   }
//   next();
// });

// 动态设置favicon
function setFavicon() {
  var link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  link.href = store.state.favicon;
  document.getElementsByTagName("head")[0].appendChild(link);
}



// WEBPACK FOOTER //
// ./src/main.js